import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import request from '../../service/request';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import nopropertyfoundimg from "../../rels_assets/images/property/no-propertyfound.png";
import footerLogo from "../../rels_assets/images/logo-footer.svg";

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};

const useStyles = makeStyles((theme) => ({
  headerStyle: {
    color: '#fff',
    backgroundColor: '#FF385C',
  },
  boldStyle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
  },
  normalStyle: {
    fontSize: theme.typography.pxToRem(15),
  },
}));

const SharedPropertyDetails = (props) => {
    let { slug } = useParams();
    
    const classes = useStyles();
    const [expanded, setExpanded] = useState('panel0');
    const [isLoading, setIsLoading] = useState(true);
    const [urlNotFound, setUrlNotFound] = useState(false);
    const [properties, setProperties] = useState([]);
    const [settings, setSettings] = useState([]);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }

    var carouselSetting = {
        autoPlay: false,
        interval: 5000,
        infiniteLoop: true,
        transitionTime: 1000,
        showStatus: false,
        showArrows: true,
        showThumbs: true,
        thumbWidth: 127,
    }

    const loadData = () => {
        request({
            method: 'post',
            url: 'properties-by-slug',
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            data: { 'slug': slug }
        }).then((response) => {
            console.log('object', response.data);
            if (response.data.code == 0) {
                setProperties(response.data.data);
                setIsLoading(false);
            } else {
                setUrlNotFound(true);
            }
        }).catch((error) => {
            setUrlNotFound(true);
        });
    };

    const loadSiteSettings = () => {
        request({
            method: 'get',
            url: '/get-menu',
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
        }).then((response) => {
            if (response?.data?.code == 0) {
                 console.log('object', response.data.data);
                setSettings(response.data.data.site_setting || []);
            }
        }).catch(() => {
            setSettings([]);
        });
    };

    useEffect(() => {
        loadData();
        loadSiteSettings();
    }, []);
    useEffect(() => {
        scrollToTop();
    }, [props]);

    return (
        <> 
            <main id="main">
                <section className='shared-property-details'>
                    <div
                        style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 999,
                            backgroundColor: '#ffffff',
                            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
                        }}
                    >
                        <div className='container'>
                            <div
                                className='d-flex align-items-center justify-content-between flex-wrap'
                                style={{ minHeight: '78px', gap: '16px', padding: '12px 0' }}
                            >
                                <div
                                    className='d-flex align-items-center flex-wrap'
                                    style={{ gap: '14px' }}
                                >
                                    <img
                                        loading='lazy'
                                        src={settings && settings.logo ? settings.logo : footerLogo}
                                        alt='logoImg'
                                        style={{ maxHeight: '70px', width: 'auto' }}
                                    />
                                </div>
                                <div className='d-flex flex-column align-items-end'>
                                    {settings && settings.name && (
                                        <h4
                                            className='m-0'
                                            style={{ fontSize: '20px', fontWeight: 700 }}
                                        >
                                            {settings.name}
                                        </h4>
                                    )}
                                    {settings && settings.mobile && (
                                        <a
                                            href={`tel:${settings.mobile}`}
                                            aria-label='mobile'
                                            style={{ fontSize: '18px', fontWeight: 600 }}
                                        >
                                            {settings.mobile}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='container' style={{ marginTop: '25px' }}>
                        {urlNotFound
                            ? <h5 className='text-center text-danger'>Your requested URL is eigther invalid or not found!</h5>
                            : !isLoading && properties.length > 0 &&
                            <div className='row'>
                                <div className='col-12'>
                                    {properties.map((property, index) => {
                                        // console.log('object', property, index);
                                        let panelId = `panel${index}`;
                                        let property_title = checkNotEmptyObjVal(property, "property_title") ? property["property_title"] : "Property Details";
                                        let address =  checkNotEmptyObjVal(property, "Area") ? property["Area"]+"," : "";
                                        address += checkNotEmptyObjVal(property, "City") ? property["City"]+"," : "";
                                        address += checkNotEmptyObjVal(property, "State") ? property["State"] : "";

                                        return (<Accordion expanded={expanded === panelId} onChange={handleChange(panelId)} key={index} className='mb-3'>
                                            <AccordionSummary
                                                expandIcon={<i className="fa fa-chevron-down text-white" style={{fontSize: '15px'}}></i>}
                                                aria-controls={`${panelId}bh-content`}
                                                id={`${panelId}bh-header`}
                                                className={classes.headerStyle}
                                            >
                                                <div className='d-flex flex-row align-items-center w-100'>
                                                    <div className='d-flex flex-column justify-content-start w-100'>
                                                        <Typography className={classes.boldStyle}>{property_title}</Typography>
                                                        {checkNotEmptyVal(address) && 
                                                        <Typography className={classes.normalStyle}><i className="fa fa-map-marker ti-location-pin "></i> {address}</Typography>}
                                                    </div>
                                                    {checkNotEmptyObjVal(property, "Property For") && 
                                                    <div className='d-flex justify-content-end w-auto'>
                                                        <span className='property-for'>{property["Property For"]}</span>
                                                    </div>}
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails className='flex-column'>
                                                {checkNotEmptyObjVal(property, "property_images") && property.property_images.length > 0 && (
                                                    <div className='w-100 mt-3'>
                                                        <h3 className="shared-property-title m-0 p-0">Gallery</h3>
                                                        <div className="carousel-inner">
                                                            <Carousel {...carouselSetting}
                                                                renderThumbs={() =>
                                                                    property.property_images.map((thumbImage, index) => {
                                                                        let filename = thumbImage.split('/').pop();
                                                                        let extension = filename.split('.').pop();
                                                                        if (extension && (['m4v', 'mp4', 'mov', 'wmv', 'avi', 'mkv'].includes(extension))) {
                                                                            return (
                                                                                <div className="active item" data-slide-number={index} key={index}>
                                                                                    <div className='img-thumbnail'>
                                                                                        <video alt="slider-listing" className='video-thumb'>
                                                                                            <source src={thumbImage} type="video/mp4" />
                                                                                        </video>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        } else {
                                                                            return (
                                                                                <div className="active item" data-slide-number={index} key={index}>
                                                                                    <img loading='lazy' src={thumbImage} className="img-fluid" alt="slider-listing" onError={(e) => (
                                                                                        e.target.onerror = null,
                                                                                        e.target.src = nopropertyfoundimg
                                                                                    )
                                                                                    } />
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                                renderArrowPrev={(clickHandler, hasPrev) => {
                                                                    return (
                                                                        <a className="carousel-control left" data-slide="prev" onClick={clickHandler}><i className="fa fa-angle-left text-white"></i></a>
                                                                    );
                                                                }}
                                                                renderArrowNext={(clickHandler, hasNext) => {
                                                                    return (
                                                                        <a className="carousel-control right" data-slide="next" onClick={clickHandler}><i className="fa fa-angle-right text-white"></i></a>
                                                                    );
                                                                }}
                                                            >
                                                                {
                                                                    property.property_images.map((thumbImage, index) => {
                                                                        let filename = thumbImage.split('/').pop();
                                                                        let extension = filename.split('.').pop();
                                                                        if (extension && (['m4v', 'mp4', 'mov', 'wmv', 'avi', 'mkv'].includes(extension))) {
                                                                            return (
                                                                                <div className='wprt-image-video' key={index}>
                                                                                    <video autoPlay muted controls className="img-fluid" alt="slider-listing" name="video-name">
                                                                                        <source src={thumbImage} type="video/mp4" />
                                                                                    </video>
                                                                                </div>
                                                                            )
                                                                        } else {
                                                                            return (
                                                                                <div className="active item" data-slide-number={index} key={index}>
                                                                                    <img loading='lazy' src={thumbImage} className="img-fluid"  alt="slider-listing" onError={(e) => (
                                                                                        e.target.onerror = null,
                                                                                        e.target.src = nopropertyfoundimg
                                                                                    )} />
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </Carousel>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className='w-100 mt-3'>
                                                    <h3 className="shared-property-title m-0 p-0">Property Details</h3>
                                                    <ul className="shared-details-list m-0 p-0">
                                                        {Object.entries(property).map(([key, val], idx) => 
                                                            notInArray(key, ["property_title", "pre_leased_title", "agent_title", "Name", "Mobile", "property_images"]) && (
                                                            <li key={`dtl${idx}`}>
                                                                <span className="font-weight-bold mx-2">{key}:</span>
                                                                <span>{checkNotEmptyVal(val) ? (key === "Map Location" ? <a href={val} target="_blank">{val}</a> : val) : "-"}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                {checkNotEmptyObjVal(property, "agent_title") && (
                                                    <div className='w-100 mt-3'>
                                                        <h3 className="shared-property-title m-0 p-0">Agent Details</h3>
                                                        <ul className="shared-details-list m-0 p-0">
                                                            {Object.entries(property).map(([key, val], idx) =>
                                                                ["Name", "Mobile"].includes(key) && (
                                                                <li key={`agt${idx}`}>
                                                                    <span className="font-weight-bold mx-2">{key}:</span>
                                                                    <span>{checkNotEmptyVal(val) ?  val : "-"}</span>
                                                                </li> 
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </AccordionDetails>
                                        </Accordion>)
                                    })}
                                </div>
                            </div>
                        }
                    </div>
                </section>
            </main>
        </>
    );
};

const checkNotEmptyObjVal = (obj, key) => {
    if (!obj || typeof obj !== "object") return false;
    const value = obj[key];
    return typeof value !== 'undefined' && value !== undefined && value !== null && value.toString().trim() !== "";
};
const notInArray = (key, arr) => !arr.includes(key);
const checkNotEmptyVal = (value) => {
    return typeof value !== 'undefined' && value !== undefined && value !== null && value.toString().trim() !== "";
};

export default SharedPropertyDetails;
